import { createContext } from "react";
import PropTypes from "prop-types";
export const ContextPropTypes = PropTypes.shape({
  showReportDialog: PropTypes.func,
  closeReportDialog: PropTypes.func
});
export default createContext({});